const languageSwitcherMobile = document.getElementById('language-switcher-mobile');

function initLanguageSwitcherMobile() {
	const select = languageSwitcherMobile.querySelector('select');
	const labels = languageSwitcherMobile.querySelectorAll('.m-language-switcher-mobile__fake-select > div');

	/**
	 * Init
	 */
	function init() {
		select.addEventListener('change', switchLanguage);
	}

	/**
	 * Handle language switch
	 */
	function switchLanguage(e) {
		const lang = e.target.selectedOptions[0].getAttribute('data-lang');

		labels.forEach(function(label) {
			label.classList.remove('active');

			if (label.getAttribute('data-lang') == lang) {
				label.classList.add('active');
			}
		});
		
		window.location.href = e.target.value;
	}

	init();
}

if (languageSwitcherMobile) {
	initLanguageSwitcherMobile();
}